import { render, staticRenderFns } from "./RegistrationsOverTimeChart.vue?vue&type=template&id=4e56a336&scoped=true&"
import script from "./RegistrationsOverTimeChart.vue?vue&type=script&lang=js&"
export * from "./RegistrationsOverTimeChart.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationsOverTimeChart.vue?vue&type=style&index=0&id=4e56a336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56a336",
  null
  
)

export default component.exports